module.exports = __webpack_public_path__ + "img/slide-5.9ee30d62.webp";